import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
const AddPersonModal = ({ show, onHide, onAddPerson }) => {
  const [name, setName] = useState("");
  const handleSubmit = (event) => {
    event.preventDefault();
    onAddPerson(name);
    setName("");
  };
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Add Person</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Label>Full Name</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(event) => setName(event.target.value)}
              required
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          type="submit"
          disabled={!name}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default AddPersonModal;
